import { Button, CircularProgress, Modal } from "@mui/material"

export interface IConfirm {
    open: boolean,
    onClose: () => void,
    onSubmit: (...args: any) => void,
    title: string
    body: string
    loading?: boolean
}
export default function Confirmation({ open, onClose, onSubmit, title, body, loading, ...args }: IConfirm) {

    return (
        <Modal
            className="flex justify-center items-center rounded-xl w-full h-full"
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            disableScrollLock
            open={open} onClose={onClose}>
            <div className="bg-white p-2 rounded-xl">
                <h2>{title}</h2>
                <p>{body}</p>

                <div className="flex flex-row justify-end">
                    <Button variant="text" disabled={loading} onClick={() => onSubmit(args)}>{loading ? <CircularProgress size={12} /> : "تایید"}</Button>
                    <Button variant="text" onClick={onClose} >انصراف </Button>
                </div>
            </div>
        </Modal>)

}